import { Result } from "appworks/model/gameplay/records/results/result";

export class EJBoardGameResult extends Result {
    public resultType = "EJBoardGameResult";

    public jokerPosition: number;

    public prizePositions: Array<{ id: number, position: number }>;
}
